module.exports = __webpack_public_path__ + "static/home-0e695096fe50225af80739f889e0d106.png";